export default class Filtros {
  constructor(
    adquirente = "",
    destinatario = "",
    finalidade = "",
    origem = "",
    ufDestino = "",
    validacaoAdquirente = false,
    validacaoDestinatario = false,
    validacaoFinalidade = false,
    validacaoOrigem = false,
    validacaoUfDestino = false,
    
  ) {
    this.adquirente = adquirente;
    this.destinatario = destinatario;
    this.finalidade = finalidade;
    this.origem = origem;
    this.ufDestino = ufDestino;
    this.validacaoAdquirente = validacaoAdquirente;
    this.validacaoDestinatario = validacaoDestinatario;
    this.validacaoFinalidade = validacaoFinalidade;
    this.validacaoOrigem = validacaoOrigem;
    this.validacaoUfDestino = validacaoUfDestino;
  }

  validaDados() {
    //adquirente
    if (this.adquirente) this.validacaoAdquirente = false;
    else {
      this.validacaoAdquirente = true;
      return 1;
    }
    //destinatario
    if (this.destinatario) this.validacaoDestinatario = false;
    else {
      this.validacaoDestinatario = true;
      return 2;
    }
    //finalidade Aquisicao
    if (this.finalidade) this.validacaoFinalidade = false;
    else {
      this.validacaoFinalidade = true;
      return 3;
    }
    //origem Mercadoria
    if (this.origem) this.validacaoOrigem = false;
    else {
      this.validacaoOrigem = true;
      return 4;
    }
    //UF Destino
    if (this.ufDestino) {
      this.validacaoUfDestino = false;
      return 0;
    } else {
      this.validacaoUfDestino = true;
      return 5;
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Filtro.js